<template>
  <div class="table-page-search-wrapper">
    <a-form-model :model="queryParams" layout="inline" :labelCol="{ style: { flex: '0 0 90px' } }">
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="加工组织" prop="desOrganizationCode">
            <global-select
              v-model="queryParams.desOrganizationCode"
              :selectData="inventOrg"
              @change="getBomWorkshopFindList"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :disabled="isDisableOrganization"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="车间" prop="workCode">
            <a-select
              v-model="queryParams.workCode"
              option-label-prop="label"
              @change="onChangeWorkCode"
              allowClear
            >
              <a-select-option v-for="(item) in workshopCodeList" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopDesc">
                {{ item.workshopCode }}-{{ item.workshopDesc }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="工作中心" prop="workCenterCodeList">
            <global-select
              :value.sync="queryParams.workCenterCodeList"
              selectType="selectAssembleMultipleSearch"
              assembleLabel
              searchParam="centerName"
              focusGet
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ organizationCode: queryParams.desOrganizationCode }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="班组" prop="teamGroupCodeList">
            <global-select
              :value.sync="queryParams.teamGroupCodeList"
              selectType="selectAssembleMultipleSearch"
              assembleLabel
              searchParam="teamName"
              focusGet
              requestApi="/bom/team/list"
              :selectItem="{ value: 'teamCode', label: 'teamName' }"
              :setParams="{ organizationCode: queryParams.desOrganizationCode }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-show="advanced">
        <a-col :md="6" :sm="24">
          <a-form-item label="工艺大类">
            <global-select
              :value.sync="queryParams.productBroadCategoryList"
              selectType="selectMultipleFilter"
              requestApi="/mes/mesDiscreteJobsCc/findCategoryComboBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              :dropdown-match-select-width="false"
            />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="业务类型" prop="businessTypeList">
            <global-select
              selectType="selectMultiple"
              v-model="queryParams.businessTypeList"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'MES_MO_CC_TYPE' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="物料编码">
            <global-select
              :value.sync="queryParams.assemblyItemCode"
              selectType="selectSearch"
              requestApi="/mes/mesDiscreteJobs/assemblyBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              searchParam="itemCode"
              :dropdown-match-select-width="false"
            />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="MO号" prop="wipEntityNameVal">
            <a-input v-model="queryParams.wipEntityNameVal" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="MO票号" prop="moTicketCodeVal">
            <a-input v-model="queryParams.moTicketCodeVal" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="MO票状态" prop="statusList">
            <global-select
              selectType="selectMultiple"
              v-model="queryParams.statusList"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'MES_MO_JOB_STATUS_TICKET' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="父级工单号" prop="upstreamWorkNumberVal">
            <a-input v-model="queryParams.upstreamWorkNumberVal" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="领料单号" prop="requisitionCode">
            <a-input v-model="queryParams.requisitionCode" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="计划单号" prop="orderNoVal">
            <a-input v-model="queryParams.orderNoVal" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="计划开始时间" prop="scheduledStartDate">
            <a-range-picker
              v-model="queryParams.scheduledStartDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="计划完成时间" prop="scheduledCompletionDate">
            <a-range-picker
              v-model="queryParams.scheduledCompletionDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="一次达交考核时间" :labelCol="{ style: { flex: '0 0 120px' } }" prop="deliveryDate">
            <a-range-picker
              v-model="queryParams.deliveryDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="变更后考核时间" :labelCol="{ style: { flex: '0 0 120px' } }" prop="assessmentDeliveryDate">
            <a-range-picker
              v-model="queryParams.assessmentDeliveryDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="是否合格" prop="qualifiedFlag">
            <global-select
              v-model="queryParams.qualifiedFlag"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SYS_YES_NO' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="派工时间" prop="dispatchingDate">
            <a-range-picker
              v-model="queryParams.dispatchingDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="开工时间" prop="startDate">
            <a-range-picker
              v-model="queryParams.startDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24" >
          <a-form-model-item label="完工时间" prop="completionDate">
            <a-range-picker
              v-model="queryParams.completionDate"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="创建时间" prop="createTime">
            <a-range-picker
              v-model="queryParams.createTime"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="大货类型" prop="orderType">
            <global-select
              v-model="queryParams.orderType"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'ORDER_TYPE' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="组件物料" prop="componentItemCodeList">
            <global-select
              v-model="queryParams.componentItemCodeList"
              :focusGet="true"
              :dropdown-match-select-width="false"
              selectType="selectMultipleSearch"
              requestApi="/scp/scpMrpSystemItems/planItemsBoxNew"
              :selectItem="{ value: 'selectedValue', label: 'label', thirdLabel: 'selectedValue' }"
              :setParams="{ organizationCode: 'A001' }"
              searchParam="label"
              sourseField="res"
              :totalNum="9999999999"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="发料状态" prop="issueFlag">
            <a-select v-model="queryParams.issueFlag">
              <a-select-option v-for="item in DISPATCH_STATUS" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="发料时间" prop="issueTime">
            <a-range-picker
              v-model="queryParams.issueTime"
              valueFormat="YYYY-MM-DD"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24"></a-col>
      </a-row>
      <a-row>
        <a-col :md="24" :sm="24" class="aj-center-between">
          <a-form-model-item label="快捷过滤" class="mo-search-filter">
            <a-button v-for="item in searchShowList" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
            <a-dropdown v-if="moreSearchShowList.length > 0">
              <a-menu slot="overlay">
                <a-menu-item v-for="item in moreSearchShowList" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
              </a-menu>
              <a-button type="link">更多<a-icon type="down" /> </a-button>
            </a-dropdown>
            <a-button @click="$refs.dressingByScreening.show(queryParams)">保存筛选方案</a-button>
          </a-form-model-item>
          <span class="table-page-search-submitButtons">
            <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
            <a-button @click="handleSearch" type="primary" class="ml8">查询</a-button>
            <a-button @click="resetQuery" class="ml8">重置</a-button>
            <a @click="toggleAdvanced" class="ml8">
              {{ advanced ? '收起' : '展开' }}
              <a-icon :type="advanced ? 'up' : 'down'"/>
            </a>
          </span>
        </a-col>
      </a-row>
    </a-form-model>
    <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="() => getCategoryIdList()" />
    <dressing-by-screening ref="dressingByScreening" @handle-success="() => getCategoryIdList()" />
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import { mapState } from 'vuex';
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { apiScpScreeningSchemeSearchAllScheme } from '@/api/mes/workOrderManage/workOrderDesk'
import { apiBomWorkshopFindList } from '@/api/mes/basedata/factoryAssembly'
import moment from 'moment'
import { DISPATCH_STATUS, FEED_STATUS, STATUS_CODE_TAB_V } from '@/views/mes/workOrderManage/ticketsManageCc/common'

export default {
  name: 'SearchForm',
  components: { DressingByScreening, DressingByScreeningSetUp },
  props: {
    activeStateKey: String
  },
  data() {
    this.dateList = [
      'createTime', 'dispatchingDate', 'completionDate', 'dispatchingDate', 'startDate',
      'scheduledStartDate', 'scheduledCompletionDate', 'deliveryDate', 'assessmentDeliveryDate',
      'issueTime'
    ];
    return {
      workshopCodeList: [],
      advanced: true,
      searchList: [],
      queryParams: {}
    }
  },
  computed: {
    FEED_STATUS() {
      return FEED_STATUS
    },
    DISPATCH_STATUS() {
      return DISPATCH_STATUS
    },
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode,
      inventOrg: (state) => state.user.inventOrg
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    },
    searchShowList() {
      return this.searchList.slice(0, 3);
    },
    moreSearchShowList() {
      return this.searchList.slice(3);
    },
    inVisibleList() {
      if(this.activeStateKey !== STATUS_CODE_TAB_V.ALL.lookupCode) {
        return ['status'];
      }else {
        return [];
      }
    }
  },
  created() {
    this.queryParams = this.getInitialValue();
  },
  mounted() {
    this.getBomWorkshopFindList();
  },
  methods: {
    handleSearch() {
      this.onChangeCopyFormExcel('wipEntityNameVal', 'wipEntityNameList')
      this.onChangeCopyFormExcel('moTicketCodeVal', 'moTicketCodeList')
      this.onChangeCopyFormExcel('upstreamWorkNumberVal', 'upstreamWorkNumberList')
      this.onChangeCopyFormExcel('orderNoVal', 'orderNoList')
      const values = { ...this.queryParams };
      for(const filed in values) {
        if(isNil(values[filed]) || values[filed] === '') {
          delete values[filed]
        }
      }
      for(const filed of this.dateList) {
        this.resolveDatePick(values, filed);
      }
      this.$emit("search", values);
    },
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(valField, listField) {
      const listVal = []
      if (this.queryParams[valField]) {
        const list = this.queryParams[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      this.queryParams[listField] = listVal
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = this.getInitialValue();
      this.handleSearch();
    },
    getInitialValue() {
      return {
        desOrganizationCode: this.organizationCodeOrigin
      }
    },
    onChangeWorkCode() {
      // this.$set(this.queryParams, 'workCenterCodeList', undefined);
      // this.$set(this.queryParams, 'teamGroupCodeList', undefined);
    },
    // 车间编码
    getBomWorkshopFindList () {
      this.$set(this.queryParams, 'workCode', undefined);
      this.$set(this.queryParams, 'workCenterCodeList', undefined);
      this.$set(this.queryParams, 'teamGroupCodeList', undefined);
      this.workshopCodeList = []
      if (!this.queryParams.desOrganizationCode) {
        return false
      }
      apiBomWorkshopFindList({ organizationCode: this.queryParams.desOrganizationCode }).then(res => {
        this.workshopCodeList = res
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      return apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          res.data.forEach((element, index) => {
            arr.push(element)
            if (flag && element.defaultFlag === "Y") {
              this.queryParams = JSON.parse(element.schemeDetailJson)
            }
          });
          this.searchList = arr
        } else {
          this.searchList = []
        }
      }).finally(() => {
        this.handleSearch()
      })
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.queryParams = JSON.parse(val.schemeDetailJson)
      this.handleSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
      this.$emit('toggleAdvanced', this.advanced);
    },
    // 公共选择日期
    resolveDatePick(params, field, resolveFields) {
      if (!resolveFields?.length) {
        const newField = field.charAt(0).toUpperCase() + field.slice(1);
        resolveFields = ['sta' + newField, 'end' + newField];
      }
      const value = params[field];
      if (value && value.length > 0) {
        params[resolveFields[0]] = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
        params[resolveFields[1]] = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
      }
      delete params[field];
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/.ant-form-item-control-wrapper {
    overflow: hidden;
  }
  .mo-search-filter{
    min-width: 250px;
  }
</style>
